import axios from 'axios';

// 创建 axios 实例
const service = axios.create({
  // 基础路径：所有请求都会自动加上这个前缀
  // baseURL: "http://localhost:8080/", 
  baseURL: "/api", 
  // 请求超时时间（毫秒）
  timeout: 5000 
});

// 请求拦截器：发送请求前的处理
service.interceptors.request.use(

  config => {
    // 可在此处添加请求头，如 token
    // 示例：config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    return config;
  },
  error => {
    // 请求错误处理
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器：收到响应后的处理
service.interceptors.response.use(
  response => {
    // 只返回响应数据中的 data 部分（根据实际后端接口调整）
    const res = response.data;
    // 可根据后端约定的状态码处理，例如：
    // if (res.code !== 200) {
    //   console.error('接口错误:', res.msg);
    //   return Promise.reject(new Error(res.msg || '接口请求失败'));
    // }
    
    return res;
  },
  error => {
    // 响应错误处理（如网络错误、500错误等）
    console.error('响应错误:', error);
    
    // 可根据错误状态码显示不同提示
    if (error.response) {
      switch (error.response.status) {
        case 404:
          console.error('请求的资源不存在');
          break;
        case 500:
          console.error('服务器内部错误');
          break;
        // 其他状态码处理...
      }
    }
    
    return Promise.reject(error);
  }
);

export default service;
    